<div class="basicrow m-bott-ii" >
    <div class="userinfo full nomtops">
        <div class="basicrow">	
            <div class="basicrow f-bmed roboto-b ">
                Resumen de Pago
            </div>
            <!-- <div class="redstat" ng-if="this.screenPaymentType==1">
                <div class="autorow roboto-r pull-left">
                    Equipo
                </div>

                <div class="autorow roboto-b pull-right">
                    {{this.equipmenttoPay}}
                </div>
            </div>
            <div class="redstat"  ng-if="this.screenPaymentType!=1">
                <div class="autorow roboto-r pull-left">
                    Producto
                </div>

                <div class="autorow roboto-b pull-right">
                    {{this.equipmenttoPay}}
                </div>
            </div>

            <div class="redstat m-top-ii" ng-if="this.feeToPay!=0 && this.screenPaymentType==1" >
                <div class="autorow roboto-r pull-left">
                    Cuotas
                </div>

                <div class="autorow roboto-b pull-right">
                    {{this.feeToPay}}
                </div>
            </div> -->
            <div class="redstat m-top-ii" *ngFor="let list of this.dataPay.data.labels; let i = index">
                <div class="autorow roboto-r pull-left">
                    {{list.label}}
                </div>

                <div class="autorow roboto-b pull-right">
                    {{list.text}}
                </div>
            </div>
        </div>
    </div>
</div>